var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.62 176.65",
    style: {
      enableBackground: "new 0 0 104.62 176.65"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45,89.61c0-0.62,0-1.24,0-1.87c0.05-0.16,0.13-0.32,0.16-0.49c0.3-1.97,1.21-3.63,2.61-5.03 c10.69-10.69,21.37-21.37,32.06-32.06C51.62,34.82,66.96,19.48,82.31,4.13c1.06-1.06,2.27-1.88,3.71-2.33 c0.53-0.17,1.08-0.31,1.61-0.46c0.78,0,1.55,0,2.33,0c0.1,0.05,0.21,0.12,0.32,0.14c2.1,0.33,3.78,1.39,5.25,2.89 c1.86,1.89,3.75,3.76,5.63,5.64c1.11,1.11,1.99,2.37,2.44,3.9c0.18,0.59,0.31,1.19,0.46,1.78c0,0.62,0,1.24,0,1.87 c-0.04,0.08-0.12,0.16-0.13,0.25c-0.3,2.33-1.52,4.13-3.15,5.75c-4.94,4.89-9.85,9.83-14.76,14.75 C74.34,49.98,62.67,61.66,50.99,73.34c-4.95,4.95-9.89,9.9-14.85,14.83c-0.38,0.38-0.4,0.6,0,0.96c0.62,0.56,1.19,1.17,1.78,1.76 c16.55,16.56,33.1,33.12,49.65,49.68c4.45,4.45,8.9,8.91,13.36,13.35c1.2,1.2,2.19,2.52,2.69,4.16c0.17,0.57,0.3,1.16,0.44,1.73 c0,0.62,0,1.24,0,1.87c-0.05,0.14-0.14,0.28-0.16,0.43c-0.29,1.97-1.19,3.64-2.59,5.04c-2.07,2.08-4.13,4.16-6.23,6.22 c-1.71,1.67-3.77,2.57-6.17,2.6c-2.7,0.03-4.9-1.05-6.79-2.95c-8.37-8.39-16.75-16.77-25.13-25.15 C39.42,130.28,21.83,112.7,4.25,95.11c-1.05-1.05-1.86-2.24-2.3-3.66C1.77,90.84,1.62,90.23,1.45,89.61z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back.913a01e2.svg";
export { ForwardRef as ReactComponent };